<form #searchForm (ngSubmit)="onSearch()" class="search-form-input" role="search" (focusout)="onFocusOut($event)">
    <label class="search-form-input__label" [class.open]="isSearchOpen" for="search" aria-label="'Search' | translate">
        <input
            #searchInput
            [formControl]="queryField"
            autocomplete="off"
            class="search-form-input__input form-control"
            id="search"
            [placeholder]="'Search' | translate"
            [tabindex]="isSearchOpen ? 0 : -1"
            type="text" />
        <span class="search-form-input__icon">
            <core-icon name="icon-search" color="var(--icon-subtle)"></core-icon>
        </span>

        @if (showClearButton) {
            <button
                (click)="resetSearch()"
                aria-label="Clear search"
                class="btn-close btn--search-clear"
                type="button"></button>
        }

        <button type="button" class="search-form-input__close-mobile" (click)="closeSearch()" aria-label="Close search">
            <span class="material-symbols-outlined close-icon close-icon__dark">close</span>
        </button>
    </label>

    <button coreButton type="submit" hidden [size]="'small'">Search</button>

    <button class="search-form-input__toggle" (click)="toggleSearch()" aria-label="Toggle search bar">
        @if (isSearchOpen) {
            <span class="material-symbols-outlined close-icon">close</span>
        } @else {
            <span class="material-symbols-outlined search-icon">search</span>
        }
    </button>
</form>
